import { render, staticRenderFns } from "./split_tab.vue?vue&type=template&id=65178ade&scoped=true&"
import script from "./split_tab.vue?vue&type=script&lang=js&"
export * from "./split_tab.vue?vue&type=script&lang=js&"
import style0 from "./split_tab.vue?vue&type=style&index=0&id=65178ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65178ade",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65178ade')) {
      api.createRecord('65178ade', component.options)
    } else {
      api.reload('65178ade', component.options)
    }
    module.hot.accept("./split_tab.vue?vue&type=template&id=65178ade&scoped=true&", function () {
      api.rerender('65178ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/payments/item/split/split_tab.vue"
export default component.exports